<template>
    <div id="InvoiceViewSidebar">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div class="web-right-sidebar"> <!--right sidebar-->
            <div class="right-asset-tab-list workorder-right-sidebar">
                <div id="tabs" class="containerTab">
                    <div class="tabs">
                        <a v-on:click="activetab=1" v-bind:class="[ activetab === 1 ? 'active' : '' ]">Invoice List</a>
                        <a v-on:click="activityLogs()" v-bind:class="[ activetab === 2 ? 'active' : '' ]">Activity</a>
                    </div>

                    <div class="content">
                        <div v-show="activetab === 1" class="tabcontent">
                            <div class="">
                                <div class=" customer-view-main">
                                    <!-- <workorder-detail></workorder-detail>     -->
                                    <div class="left-customer-view workorder-right-main-list bill-list-main-section">
                                        <template v-for="(invoice,ind) in invoicesArray">
                                            <div class="bill-data active" :key="ind" :id="'inv_' + invoice.id">
                                                <span class="bill-list-icon"> <i class="hi-icon icon-fluser-silhouette"></i> </span>
                                                <div class="bill-list-section" v-on:click="openInvoice($event,invoice)">
                                                    <h6> {{invoice.customer}} </h6>
                                                    <p> # Invoice <span> {{invoice.invoice_number}}  </span> </p>
                                                    <p class="line-seprater"> | </p>
                                                    <p> <i class="hi-icon icon-flcalendar1"></i> {{invoice.invoice_date}} </p>
                                                </div>
                                            </div>
                                        </template>

                                    </div>
                                </div>
                            <!-- </template> -->
                            </div>
                        </div>
                        <div v-show="activetab === 2" class="tabcontent" id="customer-activity-logs" >
                            <div class="col-md-12 customer-view-main">
                                <div class="row">
                                    <invoice-activity-log-list :activityLogVal="activityLogsTabValue"></invoice-activity-log-list>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';

import {commonMixins} from '../../mixins/commonMixins';
import ActivityLogListView from '@/components/ActivityLogList.vue';

Vue.component("invoice-activity-log-list", ActivityLogListView);
export default {
    name: "InvoiceViewSidebar",
    mixins:[commonMixins],
    data: () => ({
        loading:false,
        invoiceId : 0,
        activetab: 1,
        activityLogsTabValue: "invoiceloadList",
        invoicesArray:[],

    }),
    mounted: function() {
        var self = this;
        self.invoiceId = this.$route.params.id;
        self.loadCustomerInvoices();
        //add active class to current invoice
        setTimeout(function () {
            $("#inv_" + self.invoiceId).addClass("bill-active");
        }, 1500);
    },
    methods : {

        loadCustomerInvoices(){
            var self = this;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/invoices/customer",
                type: "POST",
                headers: this.ajxHeaders,
                dataType: "json",
                data:{'invoice_id':self.invoiceId},
                success: function (data) {
                    self.loading = false;

                    if (data.status == "success") {
                        self.invoicesArray = data.content;
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (jqXHR.status == 0) {
                        self.errorMsg = "Remote server cannot be reached";
                    } else {
                        //redirect to login page if user not authenticated
                        if (jqXHR.status == 401) {
                            //clear previous data
                            localStorage.removeItem("user_obj");
                            localStorage.removeItem("tkn");
                            //EventBus.$emit("logged-in", true, "", "");
                            self.$router.push("/");
                        }
                        self.error = jqXHR.responseJSON.message;
                    }
                }
            });
        },

        activityLogs(){
          var self = this;
          self.$root.$emit('activity_log_opted','invoice',self.invoiceId);
          self.activityLogsTabValue = "invoiceloadList";     // flag value set to loadList so that filters in list work properly.
          self.activetab = 2;
        },

        openInvoice(event,invoice) {
            var self = this;
            self.invoiceId = invoice.id;
            this.$parent.invoiceDetail(invoice.id,invoice.invoice_type_code,invoice.origin);
            //add active class to clicked invoice
            setTimeout(function () {
                $(".bill-data").removeClass("bill-active");
                $("#inv_" + invoice.id).addClass("bill-active");
            }, 1500);
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/invoice/InvoiceViewSidebar.vue